'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCrop = function MdCrop(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.6 28.4h26.8v3.2h-6.8v6.8h-3.2v-6.8h-16.8c-1.8 0-3.2-1.4-3.2-3.2v-16.8h-6.8v-3.2h6.8v-6.8h3.2v26.8z m16.8-3.4v-13.4h-13.4v-3.2h13.4c1.8 0 3.2 1.4 3.2 3.2v13.4h-3.2z' })
        )
    );
};

exports.default = MdCrop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/crop.js
// module id = 900
// module chunks = 36573943044255 79611799117203 213534597649335